<template>
  <div class="evaluation-box">
    <div class="evaluation-box-title">
      <div class="evaluation-box-title-left">
        {{ title }}
        <slot name="title"></slot>
      </div>
      <div class="evaluation-box-title-right">
        <div class="evaluation-box-title-right-icon"></div>
        <!-- <div class="evaluation-box-title-right-icon"></div> -->
      </div>
    </div>
    <template v-if="content">
      <div class="evaluation-box-content" v-html="content"></div>
    </template>
    <template v-else>
      <div class="evaluation-box-content">
        <slot></slot>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.evaluation-box {
  &-title {
    background-color: rgb(255, 200, 55);
    font-size: 0.3rem;
    font-weight: bold;
    border-radius: 5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.3rem;
    padding: 0.1rem 0.35rem;
    color: #111;

    &-left {
    }

    &-right {
      display: flex;
      align-items: center;

      &-icon {
        background: url(~@/assets/evaluation/droplet_icon.png) no-repeat;
        background-size: 100% 100%;
        width: 0.5rem;
        height: 0.3rem;
      }
    }
  }

  &-content {
    background-color: rgb(244, 244, 244);
    // background-color: red;
    padding: 0.3rem 0.35rem;
    border-radius: 0.5rem;
    // 底部阴影
    box-shadow: 0 0.05rem 0.1rem rgba(0, 0, 0, 0.2);
  }
}
</style>
